// For local dev, paste a valid access_token cookie value from browser DevTools here.
const LOCAL_DEV_TOKEN = '';

function getCookie(name: string): string | undefined {
  const match = document.cookie.split('; ').find(row => row.startsWith(`${name}=`));
  return match ? match.split('=').slice(1).join('=') : undefined;
}

export function getAccessToken(): string {
  return getCookie('access_token') || LOCAL_DEV_TOKEN;
}

export function getAuthHeaders(extra?: Record<string, string>): Record<string, string> {
  const token = getAccessToken();
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

/**
 * Drop-in replacement for fetch() that always sends cookies cross-origin
 * (credentials: 'include') and merges auth headers.
 * The backend reads access_token from cookies as fallback when the cookie
 * is HttpOnly and JS cannot read it.
 */
export function apiFetch(url: string, init?: RequestInit): Promise<Response> {
  const extraHeaders = (init?.headers as Record<string, string> | undefined) ?? {};
  return fetch(url, {
    ...init,
    credentials: 'include',
    headers: {
      ...getAuthHeaders(),
      ...extraHeaders,
    },
  });
}
